import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {PowerOfAttorney, PowerOfAttorneySearchParams} from '@accounting/_common/models/powerofattorney.models';

export const CheckState = createAction(
    '[PowerOfAttorneys] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: PowerOfAttorney[] } }>()
);

export const CheckStateSuccess = createAction(
    '[PowerOfAttorneys] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: PowerOfAttorney[] } }>()
);

export const LoadList = createAction(
    '[PowerOfAttorneys] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[PowerOfAttorneys] Load List Success',
    props<{ payload: { items: PowerOfAttorney[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[PowerOfAttorneys] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[PowerOfAttorneys] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[PowerOfAttorneys] Set Filter',
    props<{ payload: PowerOfAttorneySearchParams }>()
);

export const SetLoading = createAction(
    '[PowerOfAttorneys] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[PowerOfAttorneys] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[PowerOfAttorneys] Update Item Success',
    props<{ payload: PowerOfAttorney }>()
);

export const DeleteItem = createAction(
    '[PowerOfAttorneys] Delete Item',
    props<{ payload: PowerOfAttorney }>()
);

export const DeleteItemSuccess = createAction(
    '[PowerOfAttorneys] Delete Item Success',
    props<{ payload: PowerOfAttorney }>()
);

export const DeleteItemFailure = createAction(
    '[PowerOfAttorneys] Delete Item Failure',
    props<{ payload: PowerOfAttorney }>()
);

export const SetInitialState = createAction(
    '[PowerOfAttorneys] Set Initial State'
);
